import BasePopupFormBuilder from "./BasePopupFormBuilder";

export class FormBuilder_s10llatv0gxtgp9 extends BasePopupFormBuilder {
    constructor(
        {
            submitText = 'Download Now'
        } = {}
    ) {
        super({
            formAction: '/wp-content/themes/zerif-pro/submitClTrial.php',
            formName: 's10llatv0gxtgp9',
            title: 'Activate Your Free On-Prem Analytics Trial Now!',
            description: 'Install our free trial in minutes.',
            submitText,
        });
    }

    build(
        {
            container,
        }
    ) {
        super.build({
            container,
        });

        /** @type {HTMLElement|null} */
        const countryInput = container.querySelector('form .country-input');
        if (countryInput) {
            countryInput.name = 'Field6'
        }
    }
}
